import { useEffect } from 'react';

/**
 * @deprecated This hook goes against the React rules of hooks, and could not be optimized by the React 19 compiler.
 * Please use the `useEffect` hook and specify all the relevant dependencies
 * @example
 * ```js
 * useEffect(() => {
 *  dataRequest();
 * }, [dataRequest])
 * ```
 */
export const useMount = (onMountCb) =>
    useEffect(() => {
        onMountCb();

        // explicitly return undefined because no cleanup is needed.
        return undefined;

        // We disable the react-hooks/exhaustive-deps eslint rule for this line because we want
        // `onMountCb` to be called once and only once, even if it changes from props passed down from above.
        // If we added `onMountCb` to this deps array, it would be called 1. on mount and 2. each time
        // the value of this variable changes from props, which is unexpected and different than the
        // behavior of componentDidMount. Basically, "I'm 99% sure I know what I'm doing here"TM

        // TODO(https://perpay.atlassian.net/browse/KEY-3811):
        // React Compiler has skipped optimizing this component because one or more React ESLint rules were disabled. React Compiler only works when your components follow all the rules of React, disabling them may result in unexpected or incorrect behavior
        // eslint-disable-next-line react-compiler/react-compiler
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
